import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  deleteUserType,
  getUserTypes,
  postUserType,
  updateUserType
} from '../lib/api'
import { RootState } from '../store'

type UserTypeState = {
  types: Array<APIUserType>
  loaded: boolean
  loading: boolean
  error: null | any
}

const initialState: UserTypeState = {
  types: [],
  loaded: false,
  loading: false,
  error: null
}

export const userTypeSlice = createSlice({
  name: 'userType',
  initialState,
  reducers: {
    loading: (state: UserTypeState) => {
      state.loading = true
    },
    load: (
      state: UserTypeState,
      { payload }: PayloadAction<Array<APIUserType>>
    ) => {
      state.types = payload
      state.loaded = true
      state.loading = false
    },
    add: (state: UserTypeState, { payload }: PayloadAction<APIUserType>) => {
      state.types.push(payload)
    },
    remove: (state: UserTypeState, { payload }: PayloadAction<string>) => {
      const copy = state.types.filter(t => t.id !== payload)
      state.types = copy
    },
    update: (state: UserTypeState, { payload }: PayloadAction<APIUserType>) => {
      const copy = state.types.map(t => {
        if (t.id === payload.id) {
          return payload
        }
        return t
      })
      state.types = copy
    },
    failed: (state: UserTypeState, { payload }: PayloadAction<any>) => {
      state.error = payload
      state.loading = false
      state.loaded = true
    }
  }
})

export default userTypeSlice.reducer

export const { loading, load, add, remove, update, failed } =
  userTypeSlice.actions

// Asynchronous thunk action
export function fetchTypes () {
  return async dispatch => {
    dispatch(loading())
    try {
      const types = await getUserTypes()
      dispatch(load(types))
    } catch (error) {
      dispatch(failed(error))
    }
  }
}

// Asynchronous thunk action
export function addType (name, external) {
  return async dispatch => {
    const newType = await postUserType({ name, external })
    dispatch(add(newType))
  }
}

// Asynchronous thunk action
export function deleteType (id) {
  return async dispatch => {
    await deleteUserType(id)
    dispatch(remove(id))
  }
}

// Asynchronous thunk action
export function updateType (id, name, external) {
  return async dispatch => {
    const updated = await updateUserType(id, { name, external })
    dispatch(update(updated))
  }
}

export const selectUserType = (state: RootState) => state.userType
